import {
  BUSINESS_ACCOUNT_ROLE_META,
  type BusinessAccountRole,
} from '@stopal/shared/business-role'

import type { StatusPresetMap } from './types'

// Single-source taxonomy: the value set and its labels live in
// `@stopal/shared/business-role` (the DB enum derives from the same array).
export type { BusinessAccountRole } from '@stopal/shared/business-role'

/**
 * What a member may do inside their own business account, as a tag.
 *
 * The label and the description are READ from the shared registry rather than
 * retyped, so the tag can never disagree with the wording the invite email and
 * the role picker use. Only the tone is decided here — the domain layer's job
 * is to declare meaning, and a colour is meaning, not a rendering choice.
 *
 * Tones follow the approved mockup for the first three. Scanner had none
 * assigned there (the role postdates it) and takes `accent`: it is the one
 * role defined by a job rather than by how much authority it carries, so
 * ranking it on the neutral→success→info scale would say something false about
 * it either way.
 *
 * Keyed exhaustively over `BusinessAccountRole`, so a fifth preset fails
 * compilation here instead of rendering as a raw enum string.
 */
export const businessAccountRolePresets: StatusPresetMap<BusinessAccountRole> =
  {
    admin: {
      label: BUSINESS_ACCOUNT_ROLE_META.admin.label,
      description: BUSINESS_ACCOUNT_ROLE_META.admin.description,
      tone: 'info',
    },
    manager: {
      label: BUSINESS_ACCOUNT_ROLE_META.manager.label,
      description: BUSINESS_ACCOUNT_ROLE_META.manager.description,
      tone: 'success',
    },
    viewer: {
      label: BUSINESS_ACCOUNT_ROLE_META.viewer.label,
      description: BUSINESS_ACCOUNT_ROLE_META.viewer.description,
      tone: 'neutral',
    },
    scanner: {
      label: BUSINESS_ACCOUNT_ROLE_META.scanner.label,
      description: BUSINESS_ACCOUNT_ROLE_META.scanner.description,
      tone: 'progress',
    },
  }
